import React, { Component } from "react";
import MainHeader from "components/templateParts/MainHeader";
import dataProvider, { GET_ONE } from "providers/dataProvider";
import Can from "Can";
import styles from "./RequisitionsShow.module.scss";
import { withAuthCenter } from "AuthCenter";
import { compose } from "redux";
import { cloneDeep } from "lodash";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import {
  IssuesContainer,
  ViewContainer,
  LocationsContainer,
  SpecimenContainer,
  StatusContainer,
  TestsContainer,
  ReportsDeliveryContainer,
  ActivityContainer,
  LabNotesContainer,
  BillingContainer,
  PaymentsContainer,
  PatientHistory,
} from "./Tabs";
import clsx from "clsx";
import AddPostButton from "components/ui_components/buttons/AddPostButton";
import EditTrfContainer from "../RequisitionsCreateNew/EditTrfContainer";
import { userRoles } from "config/userRoles";
import helpers from "utils/helpers";
import ProgressBar from "components/ui_components/ProgressBar/ProgressBar";

const specialBilledStatuses = [
  "READYBILL",
  "INBILL",
  "BILL",
  "OABILL",
  "XEROBILL",
  "INSPAYRECD",
  "INVOICE",
  "PATPAYRECD",
  "MISSBILL",
  "HOLD",
  "EOB",
  "NONCOLLECT",
];

class RequisitionsShowContainer extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.tabsConfigById = [
      "view",
      "issues",
      "specimens",
      "locations",
      "tests",
      "status",
      "reportsDelivery",
      "activity",
      "labNotes",
      "billing",
      "payments",
      "patientHistory",
    ];

    this.state = {
      data: null,
      reqDataLoading: false,
      reqID: this.props.match.params.id,
    };
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return (
      JSON.stringify(nextProps) !== JSON.stringify(this.props) ||
      JSON.stringify(this.state) !== JSON.stringify(nextState)
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.loadData();
    }
    if (prevProps.authCenter.token !== this.props.authCenter.token) {
      this.loadData();
    }
  }

  componentDidMount() {
    if (helpers.can([userRoles.sales])) {
      this.tabsConfigById = [
        "view",
        "issues",
        "specimens",
        "tests",
        "status",
        "reportsDelivery",
        "billing",
      ];
    } else if (helpers.can([userRoles.collaborator])) {
      this.tabsConfigById = [
        "view",
        "issues",
        "specimens",
        "tests",
        "status",
        "reportsDelivery",
        "billing",
      ];
    }

    this.loadData();
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadData() {
    this.setState({
      reqDataLoading: true,
    });
    dataProvider(GET_ONE, "requisitions", {
      id: this.props.match.params.id,
    }).then(({ data, total }) => {
      if (this._isMounted) {
        if (!data) {
          this.setState({ reqDataLoading: false });
          return;
        }

        const isPlaceHolder = data.isPlaceHolderReq === 1 || (data.isPlaceHolderReq !== 0 && (data.isPlaceHolder || data.patientLastName === "[PLACE_HOLDER]" || data.patientFirstName === "[PLACE_HOLDER]" || data.clientName === "[PLACE_HOLDER]"));
        if (isPlaceHolder && this.props.match.params.tabSlug !== 'issues') {
          this.props.history.push(`/edit-trf/${data.id}`);
          return;
        }

        this.setState({
          reqDataLoading: false,
          dataLoaded: true,
          data: data,
        });
      }
    });
  }

  handleRequisitionUpdate = () => {
    this.loadData();
  };

  handlePatientInformationUpdate = () => {
    this.loadData();
  };

  setReqDataByKey = (data, key) => {
    const updatedData = cloneDeep(this.state.data);
    updatedData[key] = data[key];

    this.setState({
      data: updatedData,
    });
  };

  handleTabChange = (id) => {
    const { history, match } = this.props;
    // Construct base URL without tab slug to avoid double nesting
    const baseUrl = `/requisitions/${match.params.id}/show`;
    history.push(`${baseUrl}/${id}`);
  };

  render() {
    const { data, dataLoaded, reqDataLoading } = this.state;
    if (reqDataLoading) {
      return (
        <div className={styles.root}>
          <ProgressBar />
        </div>
      );
    }
    let dobFmt = this.state.data?.patientDob;
    if (dobFmt) {
      try {
        const date = new Date(dobFmt);
        if (!isNaN(date.getTime())) {
          const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
          const dd = String(date.getUTCDate()).padStart(2, '0');
          const yyyy = date.getUTCFullYear();
          dobFmt = `${mm}/${dd}/${yyyy}`;
        }
      } catch (e) {
        // ignore
      }
    }

    const title = this.state.data
      ? `#${this.state.data.id} | ${this.state.data.patientLastName
        ? `${this.state.data.patientLastName}, ${this.state.data.patientFirstName}`
        : this.state.data.patientFirstName
      } (${dobFmt})`
      : null;
    const tabsConfigByHash = {
      view: {
        label: "View",
        component: (
          <ViewContainer
            {...this.props}
            reqID={this.props.match.params.id}
            reqData={this.state.data}
            handleRequisitionUpdate={this.handleRequisitionUpdate}
            reqDataLoading={reqDataLoading}
          />
        ),
      },
      issues: {
        label: "Issues",
        component: (
          <IssuesContainer
            reqID={this.props.match.params.id}
            reqData={this.state.data}
          />
        ),
      },
      specimens: {
        label: "Specimens",
        component: (
          <SpecimenContainer
            reqID={this.props.match.params.id}
            reqData={this.state.data}
          />
        ),
      },
      locations: {
        label: "Locations",
        component: (
          <LocationsContainer
            reqID={this.props.match.params.id}
            labID={
              dataLoaded ? (data.hasOwnProperty("labId") ? data.labId : "") : ""
            }
          />
        ),
        mainHeader: {
          title: "Locations",
        },
      },
      tests: {
        label: "Tests",
        component: (
          <TestsContainer
            reqID={this.props.match.params.id}
            reqData={this.state.data}
          />
        ),
      },
      status: {
        label: "Status",
        component: (
          <StatusContainer
            reqID={this.props.match.params.id}
            reqStatusCode={
              dataLoaded
                ? data.hasOwnProperty("reqStatusCode")
                  ? data.reqStatusCode
                  : ""
                : ""
            }
            reqBillStatusDesc={
              dataLoaded
                ? data.hasOwnProperty("reqBillStatusDesc")
                  ? data.reqBillStatusDesc
                  : ""
                : ""
            }
            handleRequisitionUpdate={this.handleRequisitionUpdate}
          />
        ),
        mainHeader: {
          title: "Requisition Status",
        },
      },
      reportsDelivery: {
        label: "Reports/Delivery",
        component: (
          <ReportsDeliveryContainer
            reqID={this.props.match.params.id}
            isDemQcPass={dataLoaded ? data.isDemQcPass : 0}
          />
        ),
        mainHeader: {
          title: "Requisition Reports/Delivery",
        },
      },
      activity: {
        label: "Activity",
        component: <ActivityContainer reqID={this.props.match.params.id} />,
        mainHeader: {
          title: "Requisition Activity",
        },
      },
      labNotes: {
        label: "QA Notes",
        component: <LabNotesContainer reqID={this.props.match.params.id} />,
        mainHeader: {
          title: "Requisition QA Notes",
        },
      },
      billing: {
        label: "Billing",
        component: (
          <BillingContainer
            reqID={this.props.match.params.id}
            reqData={this.state.data}
            handlePatientInformationUpdate={this.handlePatientInformationUpdate}
            setReqDataByKey={this.setReqDataByKey}
          />
        ),

        mainHeader: {
          title: "Requisition Billing",
        },
      },
      payments: {
        label: "Payments",
        component: <PaymentsContainer reqID={this.props.match.params.id} />,
        mainHeader: {
          title: "Requisition Payments",
        },
      },
      patientHistory: {
        label: "Patient History",
        component: <PatientHistory reqData={this.state.data} />,
        mainHeader: {
          title: "Patient History",
        },
      },
      editTrf: {
        label: "Edit TRF",
        component: (
          <EditTrfContainer reqID={this.props.match.params.id} isTab={true} />
        ),
        mainHeader: {
          title: "Edit TRF",
        },
      },
    };

    const currentTabComponent = (props) => {
      let isPlaceholder = false;
      if (this.state.data) {
        isPlaceholder = (this.state.data.isPlaceHolderReq === 1 || (this.state.data.isPlaceHolderReq !== 0 && (this.state.data.isPlaceHolder || this.state.data.patientLastName === "[PLACE_HOLDER]" || this.state.data.patientFirstName === "[PLACE_HOLDER]" || this.state.data.clientName === "[PLACE_HOLDER]")));
      } else if (props.match.params.tabSlug === "editTrf") {
        isPlaceholder = true;
      }
      const activeTabsIds = isPlaceholder ? ["editTrf", "issues"] : this.tabsConfigById;

      let tabID = props.match.params.tabSlug;
      const validTabs = this.state.data ? activeTabsIds : [...activeTabsIds, "editTrf"];
      if (!tabID || !validTabs.includes(tabID)) {
        tabID = activeTabsIds[0] || "view";
      }

      const currentTab = tabsConfigByHash[tabID] || tabsConfigByHash["view"];

      let statusLink = "/requisitions?status=";

      if (this.state.data) {
        if (specialBilledStatuses.includes(this.state.data.reqStatusCode)) {
          statusLink += "Billed";
        } else {
          statusLink += this.state.data.reqStatusDesc;
        }
      }

      return (
        <div>
          <MainHeader
            title={
              currentTab.hasOwnProperty("mainHeader") &&
                currentTab.mainHeader.hasOwnProperty("title")
                ? currentTab.mainHeader.title
                : "View Requisition"
            }
            button={
              <div className={styles.mainHeaderButtonGroup}>
                <div className={styles.mainHeaderButtonWrap}>
                  <Can
                    allowedRoles={[
                      userRoles.admin, userRoles.management,
                      userRoles.lisstaff,
                    ]}
                  >
                    <AddPostButton
                      title="Requisition"
                      onClick={() =>
                        this.props.history.push("/requisitions/create")
                      }
                    />
                  </Can>
                </div>
                {currentTab.hasOwnProperty("mainHeader") &&
                  currentTab.mainHeader.hasOwnProperty("button") ? (
                  <div className={styles.mainHeaderButtonWrap}>
                    {currentTab.mainHeader.button}
                  </div>
                ) : null}
              </div>
            }
          />
          <div className={clsx([styles.introBar])}>
            <div className={`${"singlePage__container"}`}>
              <div className={styles.introBarTitle}>
                <span>{title}</span>

                {this.state.data && (
                  <Link className={styles.currentStatus} to={statusLink}>
                    {this.state.data.reqStatusDesc}
                  </Link>
                )}
              </div>

              {this.state.data?.sourceReqId && (
                <div className={styles.copyBarTitle}>
                  <span>Copy of #{this.state.data.sourceReqId}</span>
                </div>
              )}

              <ul className={styles.tabControls}>
                {activeTabsIds.map((id) => (
                  <li
                    key={id}
                    onClick={this.handleTabChange.bind(this, id)}
                    className={clsx(
                      { [styles.tabItem__active]: id === tabID },
                      [styles.tabItem]
                    )}
                  >
                    {tabsConfigByHash[id].label}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {this.state.dataLoaded ? currentTab.component : null}
        </div>
      );
    };

    return (
      <div className={styles.root}>
        {currentTabComponent(this.props)}
      </div>
    );
  }
}

// HOC to inject route params and history into class component
const withRouterParams = (Component) => {
  return (props) => {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const history = { push: navigate };
    // Construct base URL without tab slug for consistent navigation
    const baseUrl = `/requisitions/${params.id}/show`;
    return <Component {...props} match={{ params, url: baseUrl }} history={history} location={location} />;
  };
};

export default compose(withAuthCenter(), withRouterParams)(RequisitionsShowContainer);
